import React, { useState, useEffect, useRef } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../components/useTable";
import { Dimmer } from "./spinner";
import { Search } from "@material-ui/icons";
import { Mensaje, MensajeSiNo } from "../components/mensajes";
import axios from "axios";
import { formatMoneda } from "../util/varios";

const TablaPlanillaGenerada = (props) => {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code">
          {" "}
          CÓDIGO
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "descripcion",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-signature">
          {" "}
          UTE
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "codigoclase",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code-branch">
          {" "}
          CÓDIGO PLANILLA
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-cogs">
          {" "}
          OPCIONES
        </i>
      ),
      textAlign: "center",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [clase, setClase] = useState([]);
  const [operacion, setOperacion] = useState(1);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const txtBuscador = useRef();

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idplanillatimbre.includes(target.value) ||
              x.ut.includes(target.value.toLowerCase()) ||
              x.codigoplanilla
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  useEffect(() => {
    setRecords(props.planillas);
  }, [props.planillas]);

  return (
    <div style={{ backgroundColor: "#", height: "100%", width: "100%" }}>
      {/* <div className='h-2 p-5 title-table'>Clasificadores de Producción</div> */}
      <div className="row col-md-10 py-5 mx-auto">
        <div className="col-md-12 p-2 mt-4">
          <div className="row col-md-12 d-flex justify-content-between">
            <input
              type="text"
              className=" col-2 form-control form-control-sm rounded-pill"
              ref={txtBuscador}
              onChange={handleSearch}
              placeholder="Buscar"
            />
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow key={index} style={{ padding: "0" }}>
                    <TableCell style={{ textAlign: "center" }}>
                      {item.idplanillatimbre}
                    </TableCell>
                    <TableCell style={{ textAlign: "end" }}>
                      {formatMoneda(
                        item.monto.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {item.codigoplanilla}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      <button className="btn btn-sm btn-info">
                        {" "}
                        <i className="fas fa-print"> Imprimir Planilla</i>
                      </button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>

        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
      </div>
      <Dimmer active={activate} />
    </div>
  );
};
export default TablaPlanillaGenerada;



// WEBPACK FOOTER //
// ./src/components/tablaPlanillasGeneradas.js